<template>
<div class="chapter">
<div class="inner_page">
<p class="imagefp"><img alt="Death on a Vineyard Beach: Martha's Vineyard Mystery #7, by Philip R. Craig." class="imagefp" src="images/9781439105085_cover.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?58ce18b4